import React from 'react'
import { connect } from 'react-redux'
import { startOfMonth, subMonths, format, setMonth, endOfMonth, subDays, startOfWeek, endOfWeek, subWeeks, startOfYear, endOfYear, subYears, parse } from 'date-fns'

import * as actions from './actions'
import * as appActions from '../../App/actions'

import './scss/styles.scss' // main style file
import './scss/theme/default.scss' // theme css file
import { DateRange } from './components/react-date-range'

import Datepicker from '../UI/Datepicker'
import Popover from '../UI/Popover'
import Label from '../UI/Label'
import { enUS } from 'date-fns/locale'
import { getFirstDayOfWeek } from '../../helpers/getFirstDayOfWeek'

const weekStartsOn = getFirstDayOfWeek()

class FiltersPanelSettingsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      key: 'selection',
      focusedRange: [0, 0],
      open: false,
      dateStartView: startOfMonth(subMonths(new Date(), 1)),
      dateStartView1: startOfMonth(new Date()),
      pickerFirstMaxdate: endOfMonth(subMonths(new Date(), 1)),
      pickerSecondMindate: startOfMonth(new Date()),
    }
  }
  handleSelect = dates => {
    const {
      selectStartDate,
      selectEndDate,
      setTaskSettingsViewModeWeek
    } = this.props
    if (dates.selection) {
      this.setState({
        key: 'selected',
        key1: 'selected',
        focusedRange: [0, 1]
      })
      selectStartDate([
        format(dates.selection.startDate, 'yyyy-MM-dd'),
        format(dates.selection.endDate, 'yyyy-MM-dd'),
      ])
    } else {
      this.setState({
        key: 'selection',
        key1: 'selection',
        focusedRange: [0, 0]
      })
      selectEndDate([
        format(dates.selected.startDate, 'yyyy-MM-dd'),
        format(dates.selected.endDate, 'yyyy-MM-dd'),
      ])
      setTaskSettingsViewModeWeek()
      setTimeout(() => {
        this.setIsOpen(false)
      }, 700)
    }
  }

  onChangeCurrentMonthPickerFirst = selectedMonth => {
    this.setState({
      pickerSecondMindate: startOfMonth(setMonth(new Date(), selectedMonth)),
    })
  }
  onChangeCurrentMonthPickerSecond = selectedMonth => {
    this.setState({
      pickerFirstMaxdate: endOfMonth(setMonth(new Date(), selectedMonth)),
    })
  }

  pickRange = range => {
    const { selectEndDate, setTaskSettingsViewModeWeek } = this.props
    switch (range) {
      case 'today':
        selectEndDate([
          format(new Date(), 'yyyy-MM-dd'),
          format(new Date(), 'yyyy-MM-dd'),
        ])
        break
      case 'yesterday':
        selectEndDate([
          format(subDays(new Date(), 1), 'yyyy-MM-dd'),
          format(subDays(new Date(), 1), 'yyyy-MM-dd'),
        ])
        break
      case 'week':
        selectEndDate([
          format(startOfWeek(new Date(), { weekStartsOn }), 'yyyy-MM-dd'),
          format(endOfWeek(new Date(), { weekStartsOn }), 'yyyy-MM-dd'),
        ])
        break
      case 'prevWeek':
        selectEndDate([
          format(startOfWeek(subWeeks(new Date(), 1), { weekStartsOn }), 'yyyy-MM-dd'),
          format(endOfWeek(subWeeks(new Date(), 1), { weekStartsOn }), 'yyyy-MM-dd'),
        ])
        break
      case 'month':
        selectEndDate([
          format(startOfMonth(new Date()), 'yyyy-MM-dd'),
          format(endOfMonth(new Date()), 'yyyy-MM-dd'),
        ])
        break
      case 'prevMonth':
        selectEndDate([
          format(startOfMonth(subMonths(new Date(), 1)), 'yyyy-MM-dd'),
          format(endOfMonth(subMonths(new Date(), 1)), 'yyyy-MM-dd'),
        ])
        break
      case 'year':
        selectEndDate([
          format(startOfYear(new Date()), 'yyyy-MM-dd'),
          format(endOfYear(new Date()), 'yyyy-MM-dd'),
        ])
        break
      case 'prevYear':
        selectEndDate([
          format(startOfYear(subYears(new Date(), 1)), 'yyyy-MM-dd'),
          format(endOfYear(subYears(new Date(), 1)), 'yyyy-MM-dd'),
        ])
        break
      case 'entireTime':
        selectEndDate([null, null])
        break

      default:
        break
    }
    setTaskSettingsViewModeWeek()
    setTimeout(() => {
      this.setIsOpen(false)
    }, 700)
  }

  setIsOpen = isOpen => {
    this.setState({
      open: isOpen
    })
  }

  handleFilterCurrencyes = event => {
    this.props.setFilterCurrencyes(event, this.props.appState)
  }

  handleFilterPriority = event => {
    this.props.setFilterPriority(event, this.props.appState)
  }

  clearFilters = () => {
    const { mode, switchTimeMoneyMode } = this.props
    if (mode === 'money') {
      switchTimeMoneyMode()
    }
    this.props.router.navigate('/report', { replace: true })
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
  }

  render() {
    const selectedDateRange = this.props.selectedDateRange
    const selectionRange = {
      startDate: parse(selectedDateRange[0], 'yyyy-MM-dd', new Date()),
      endDate: parse(selectedDateRange[1], 'yyyy-MM-dd', new Date()),
      key: this.state.key
    }
    const { downloadXLSX, downloadCSV, selectedTaskToEditObj } = this.props

    const { dateStartView, dateStartView1 } = this.state

    const { pickerFirstMaxdate, pickerSecondMindate } = this.state
    return (
      <div className="tools_panel_placeholder">
        <div className="left">
          <Datepicker
            dateStart={selectionRange.startDate}
            loading={selectionRange.startDate}
            dateEnd={selectionRange.endDate}
            open={this.state.open}
            theme={'main_datepicker'}
            arrow={true}
            onRequestClose={() => {
              this.setIsOpen(false)
            }}
            onOpen={() => {
              this.setIsOpen(!this.state.open)
            }}
            html={
              <div
                style={{
                  display: 'flex',
                  padding: '30px 15px',
                  flexWrap: 'wrap'
                }}>
                <DateRange
                  months={1}
                  direction="horizontal"
                  ranges={[selectionRange]}
                  onChange={this.handleSelect}
                  shownDate={dateStartView}
                  date={new Date()}
                  maxDate={pickerFirstMaxdate}
                  showMonthArrow={true}
                  showDateDisplay={false}
                  showMonthAndYearPickers={false}
                  showMonthName={false}
                  focusedRange={this.state.focusedRange}
                  onShownDateChange={this.onChangeCurrentMonthPickerFirst}
                  locale={enUS}
                  weekStartsOn={weekStartsOn}
                />
                <DateRange
                  months={1}
                  direction="horizontal"
                  ranges={[selectionRange]}
                  onChange={this.handleSelect}
                  shownDate={dateStartView1}
                  date={new Date()}
                  maxDate={new Date()}
                  minDate={pickerSecondMindate}
                  showMonthArrow={true}
                  showDateDisplay={false}
                  showMonthAndYearPickers={false}
                  focusedRange={this.state.focusedRange}
                  onShownDateChange={this.onChangeCurrentMonthPickerSecond}
                  locale={enUS}
                  weekStartsOn={weekStartsOn}
                />
                <div className="datepicker_footer">
                  <div className="datepicker_footer_entire_label">
                    <p
                      className="entire_label"
                      onClick={() => {
                        this.pickRange('entireTime')
                      }}>
                      <span className="entire_label link">Entire time</span>
                    </p>
                  </div>
                  <div className="datepicker_footer_pickers">
                    <ul>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('today')
                          }}>
                          Today
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('yesterday')
                          }}>
                          Yesterday
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('week')
                          }}>
                          This week
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('prevWeek')
                          }}>
                          Last week
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('month')
                          }}>
                          This month
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('prevMonth')
                          }}>
                          Last month
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('year')
                          }}>
                          This year
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('prevYear')
                          }}>
                          Last year
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            }
          />

          <Label onClick={this.clearFilters}>
            {selectedTaskToEditObj.task.name}
          </Label>
        </div>
        <div className="right">
          <span
            className="link"
            style={{ marginRight: '17px' }}
            onClick={this.clearFilters}>
            Clear filters
          </span>
          <Popover downloadXLSX={downloadXLSX} downloadCSV={downloadCSV}>
            Export
          </Popover>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    taskId: state.app.appState.selectedTaskToEdit,
    filters: state.filtersPanel.filters,
    selectedDateRange: state.filtersPanel.selectedDateRange,
    currencyes: state.app.database.currencies,
    selectedTaskToEditObj: state.app.appState.selectedTaskToEditObj,
    mode: state.filtersPanel.tasksDisplayMode
  }
}
const mapDispatchToProps = dispatch => ({
  setFilterCurrencyes: (data, state) =>
    dispatch(actions.setFilterCurrencyes(data, state)),
  setFilterPriority: (data, state) =>
    dispatch(actions.setFilterPriority(data, state)),
  setFilterClear: () => dispatch(actions.setFilterClear()),
  selectStartDate: dates => dispatch(actions.selectStartDate(dates)),
  selectEndDate: dates => dispatch(actions.selectEndDateSettings(dates)),
  downloadXLSX: () => dispatch(actions.downloadXLSX()),
  downloadCSV: () => dispatch(actions.downloadCSV()),
  setTaskSettingsViewModeWeek: () =>
    dispatch(appActions.setTaskSettingsViewModeWeek()),
  switchTimeMoneyMode: () => dispatch(appActions.switchTimeMoneyMode())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltersPanelSettingsPage)
